import Component from '@component';
import FixScroll from '@utils/html/FixScroll';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../../colorz/configClrzApp';

export default class PredictiveSearch extends Component {
	onInit(el) {
		this.el = el;
		this.input = this.el.querySelector('.js-predictive-search-input');
		this.openSearch = document.querySelectorAll('.js-predictive-search-open');
		this.closeSearch = document.querySelector('.js-predictive-search-close');
		this.open = false;
		this.predictiveSearchForm = document.querySelector(
			'.js-predictive-search form',
		);
	}

	onReady() {
		this.openSearch.forEach((btn) => {
			// Click → open without focusing input
			btn.addEventListener('click', () => {
				this.searchOpen(btn, false);
			});

			// Enter/Space key → open and focus input
			btn.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ') {
					e.preventDefault();
					this.searchOpen(btn, true);
				}
			});
		});

		this.closeSearch.addEventListener('click', () => {
			this.searchClose();
		});
	}

	searchOpen(btn, viaKeyboard = false) {
		this.isMobile = Device.width < breakpointsApp.desktop;
		document.querySelector('.l-header').classList.add('search-open');
		btn.setAttribute('aria-expanded', 'true');
		this.el.setAttribute('aria-hidden', 'false');

		if (this.isMobile) {
			FixScroll.fix();
		}
		this.open = true;

		this.el.style.setProperty(
			'--predictive-search-form-height',
			this.predictiveSearchForm.offsetHeight + 'px',
		);

		// Only focus input when opened via keyboard
		if (viaKeyboard) {
			this.input.focus();
		}

		if (this.open) {
			document.body.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') {
					this.searchClose();
				}
			});
		}
	}

	searchClose() {
		this.isMobile = Device.width < breakpointsApp.desktop;
		document.querySelector('.l-header').classList.remove('search-open');
		if (
			document.querySelector('.js-predictive-search-open[aria-expanded=true]')
		) {
			document
				.querySelector('.js-predictive-search-open[aria-expanded=true]')
				.setAttribute('aria-expanded', 'false');
		}
		this.el.setAttribute('aria-hidden', 'true');
		this.input.value = '';
		if (this.isMobile) {
			FixScroll.unFix();
		}
		removeTrapFocus();

		if (this.isMobile) {
			document.querySelector('.js-predictive-search-open-mobile').focus();
		} else {
			document.querySelector('.js-predictive-search-open').focus();
		}
	}
}
